import {
  createContext,
  useContext,
  useState,
  useCallback,
  type ReactNode,
} from "react";

export type ChatMode = "copilot" | "openai";

interface ChatModeContextValue {
  mode: ChatMode;
  switchMode: (newMode: ChatMode) => void;
}

const MODE_STORAGE_KEY = "rfp-chat-mode";

const ChatModeContext = createContext<ChatModeContextValue | null>(null);

export function useChatMode(): ChatModeContextValue {
  const ctx = useContext(ChatModeContext);
  if (!ctx) throw new Error("useChatMode must be used within ChatModeProvider");
  return ctx;
}

export function ChatModeProvider({ children }: { children: ReactNode }) {
  const [mode, setMode] = useState<ChatMode>("copilot");

  const switchMode = useCallback((newMode: ChatMode) => {
    localStorage.setItem(MODE_STORAGE_KEY, newMode);
    setMode(newMode);
  }, []);

  return (
    <ChatModeContext.Provider value={{ mode, switchMode }}>
      {children}
    </ChatModeContext.Provider>
  );
}
